// @ts-nocheck
import { mapState, mapMutations } from 'vuex'

const mixin = {
  computed: {
    ...mapState('base', [
      'pageFilter',
      'isPageFilterExceptionCsat',
      'isPageFilterExceptionFeeling',
      'isPageFilterExceptionStatus'
    ])
  },

  methods: {
    ...mapMutations('base', {
      setIsPageFilterExceptionCsat: 'SET_IS_PAGE_FILTER_EXCEPTION_CSAT',
      setIsPageFilterExceptionFeeling: 'SET_IS_PAGE_FILTER_EXCEPTION_FEELING',
      setIsPageFilterExceptionStatus: 'SET_IS_PAGE_FILTER_EXCEPTION_STATUS'
    }),

    checkPageFilterException (filters) {
      let isException = false

      filters.forEach(filter => {
        const appliedFilter = Boolean(this.pageFilter[filter].length)

        if (appliedFilter) {
          if (!isException) {
            isException = true
          }

          if (filter === 'csat' && !this.isPageFilterExceptionCsat) {
            this.setIsPageFilterExceptionCsat(true)
          }

          if (filter === 'feeling' && !this.isPageFilterExceptionFeeling) {
            this.setIsPageFilterExceptionFeeling(true)
          }

          if (filter === 'status' && !this.isPageFilterExceptionStatus) {
            this.setIsPageFilterExceptionStatus(true)
          }
        }
      })

      return isException
    }
  }
}

export default mixin
